import { type Stats, createStats } from '../domain/stats.js';
import { type Clock, createClock } from '../domain/clock.js';
import type { LocationId } from '../domain/location.js';
import type { JobId } from '../domain/job.js';

export type Character = {
  readonly stats: Stats;
  readonly location: LocationId;
  readonly jobId: JobId | null;
  readonly lastWorkDay: number | null;
  readonly hoursWorkedToday: number;
  readonly fullWorkdaysInRole: number;
  readonly warnings: number;
  readonly hasSuit: boolean;
};

export function createCharacter(init: Partial<Character> = {}): Character {
  return Object.freeze({
    stats: init.stats ?? createStats(),
    location: init.location ?? 'casa',
    jobId: init.jobId ?? null,
    lastWorkDay: init.lastWorkDay ?? null,
    hoursWorkedToday: Math.max(0, Math.trunc(init.hoursWorkedToday ?? 0)),
    fullWorkdaysInRole: Math.max(0, Math.trunc(init.fullWorkdaysInRole ?? 0)),
    warnings: Math.max(0, Math.trunc(init.warnings ?? 0)),
    hasSuit: init.hasSuit ?? false,
  });
}

export type GameState = {
  readonly character: Character;
  readonly clock: Clock;
};

export function createGameState(init: Partial<GameState> = {}): GameState {
  return Object.freeze({
    character: init.character ?? createCharacter(),
    clock: init.clock ?? createClock(),
  });
}

export function createInitialGameState(): GameState {
  return createGameState({
    character: createCharacter({
      location: 'casa',
      jobId: 'caixa',
      stats: createStats(),
    }),
    clock: createClock({ tick: 8 }),
  });
}
